import { Component, OnInit } from '@angular/core';
import { Manufacturer } from '../../../../classes/Manufacturer';
import { GlobalService } from '../../../services/global.service';
import { LoginService } from '../../../services/login.service';
import { ModelService } from '../../../services/model.service';


@Component({
  selector: 'app-manufacturers',
  templateUrl: './manufacturers.component.html',
  styleUrls: ['./manufacturers.component.css']
})
export class ManufacturersComponent implements OnInit {

  manufacturersData: Manufacturer[] = [];
  contentVisible: boolean = false;

  availableRoles: string[] = [ 'admin' ];
  isAvailable: boolean = true;

  constructor ( 
    private model: ModelService,
    private global: GlobalService,
    private loginService: LoginService ) {
    this.global.setDocumentTitle( 'Manufacturers' );
    if ( this.availableRoles.indexOf( this.loginService.userInfo.role ) === -1 ) this.isAvailable = false;
    else this.isAvailable = true;
  }

  ngOnInit ( ) {
    this.model.getManufacturersData( ( mfData ) => {
        this.contentVisible = true;
        this.manufacturersData = mfData;
    }, true);
  }

}



// WEBPACK FOOTER //
// /root/anvel/angular/app/components/manufacturers/manufacturers/manufacturers.component.ts